<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
    yLabel: {
      type: String,
      required: false,
      default: "",
    },
    startTimestamp: {
      type: String,
      required: true,
    },
    endTimestamp: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.datasets,
      },
      {
        defaultFontColor: "#8791af",
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              offset: true,
              type: "time",
              time: {
                unit: "hour",
                tooltipFormat: "DD MMM YYYY HH:mm:ss",
                displayFormats: {
                  hour: "DD MMM YYYY HH:mm:ss",
                },
              },
              gridLines: {
                color: "rgba(166, 176, 207, 0.1)",
              },
              ticks: {
                autoSkip: true,
                autoSkipPadding: 40,
                includeBounds: true,
                min: this.startTimestamp,
                max: this.endTimestamp,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                color: "rgba(166, 176, 207, 0.1)",
              },
              scaleLabel: {
                display: true,
                labelString: this.yLabel,
              },
            },
          ],
        },
        legend: {
          position: "bottom",
        },
      }
    );
  },
};
</script>
